import { useState } from "react";
import { cn, Rail, Section } from "@hybrid-iptv/ui";
import { appArtUrl, launcher, type LauncherHome } from "./launcherApi.js";

/**
 * Home's Apps row in launcher mode (Settings → Launcher mode): every app on the box, TV and
 * phone-style (owner, 2026-10-20: "don't hide phone apps"), under the banner (owner, same day:
 * the top bar's links, then the banner, then the Apps row, then the rest of Home). It joins
 * Home's own focus grid (`data-home-row` / `data-home-col`), so the remote moves through it as
 * through the other rows. Quick settings and the rest are word links in the top bar
 * (LauncherLinks).
 */
export function LauncherRows({
  home,
  appsRow,
  isFocused,
}: {
  home: LauncherHome;
  appsRow: number;
  isFocused: (row: number, col: number) => boolean;
}) {
  const [note, setNote] = useState<string | null>(null);
  if (home.apps.length === 0) return null;
  return (
    <>
      <Section title="Apps">
        <Rail>
          {home.apps.map((app, col) => {
            const focused = isFocused(appsRow, col);
            return (
              <button
                key={app.package}
                type="button"
                className={cn("home-tile launcher-app", focused && "home-tile--focused")}
                data-home-row={appsRow}
                data-home-col={col}
                tabIndex={focused ? 0 : -1}
                onClick={() => {
                  setNote(null);
                  void launcher.openApp(app.package).catch(() => setNote(`${app.label} did not open on this box.`));
                }}
                aria-label={app.tv ? `Open ${app.label}` : `Open ${app.label} (phone app)`}
              >
                <img className="launcher-app__art" src={appArtUrl(app.package)} alt="" loading="lazy" decoding="async" />
                <span className="launcher-app__label">{app.label}</span>
                {!app.tv && <span className="launcher-app__badge">Phone app</span>}
              </button>
            );
          })}
        </Rail>
      </Section>
      {note && <p className="launcher-note" role="status">{note}</p>}
    </>
  );
}
